export default __webpack_public_path__ + "static/media/wine-saved.1da5c657.svg";